<template>
  <div class="row-span-2 md:row-span-1">
    <NuxtLink :to="props.item.url" :title="props.item.title">
      <OnImg :src="props.item.image" :title="props.item.title" :alt="props.item.title" width="140" height="105" class="w-[104px] overflow-hidden rounded md:w-auto" />
    </NuxtLink>
  </div>
  <div>
    <div class="flex flex-col">
      <div class="mb-2 md:flex">
        <NuxtLink class="text-button-l font-medium md:text-button-m" :to="props.item.url" :title="props.item.title">
          <span class="mr-1">{{ props.item.name }}</span>
          <span class="block whitespace-nowrap text-sm text-text-light md:inline">{{ props.item.productCode }}</span>
        </NuxtLink>
      </div>
      <ProductAdditionalInfo :item="props.item" class="text-text-medium" />
    </div>
    <div class="mt-4 flex flex-col gap-2 md:gap-0">
      <div v-if="props.item.regularPrice" class="flex justify-between md:basis-1/4 md:items-end md:justify-start">
        <span class="min-w-0 overflow-hidden text-ellipsis text-sm md:mr-1">{{ t['w.cart.table.regular_price_col']() }}: </span>
        <div class="flex items-center justify-end md:items-end md:justify-center">
          <Price
            class="text-base"
            :large-fractional="props.item.discountPrice !== props.item.regularPrice"
            :class="{
              'mr-1 text-sm text-text-light line-through md:text-base': props.item.discountPrice !== props.item.regularPrice,
            }"
            :amount="props.item.regularPrice"
          />
          <Price v-if="props.item.discountPrice !== props.item.regularPrice" :amount="props.item.discountPrice" class="text-base" />
        </div>
      </div>

      <div
        v-if="
          props.item.discountPrice &&
          props.item.bestPossibleVirtualCreditPrice !== props.item.discountPrice &&
          props.item.bestPossibleVirtualCreditPrice !== props.item.regularPrice
        "
        class="flex justify-between md:mt-1 md:basis-1/4 md:items-end md:justify-start"
      >
        <span class="min-w-0 overflow-hidden text-ellipsis text-sm md:mr-1">{{ t['w.cart.table.client_price_col']() }}: </span>
        <Price class="text-base text-text-strong" :amount="props.item.bestPossibleVirtualCreditPrice" />
      </div>
    </div>
  </div>
  <div class="mt-4 flex grow items-center justify-end md:mt-0">
    <Button
      v-if="props.item.forSale"
      type="button"
      class="btn-rounded btn-lg btn-product mr-4 w-auto px-4 py-2 md:mr-1"
      :is-loading="isLoadingModal"
      @click.prevent="() => addToBasket(item)"
    >
      {{ t['w.wishlist.add_item_to_cart']() }}
    </Button>
    <slot />
  </div>
  <div class="col-span-2 my-6 border-b border-border-medium md:col-span-3" />
</template>

<script setup lang="ts">
import OnImg from '~/components/on-img/OnImg.vue'
import Button from '~/components/button/Button.vue'
import Price from '~/components/price/Price.vue'
import * as t from '~/messages'
import ProductAdditionalInfo from '~/components/order/ProductAdditionalInfo.vue'
import { useProductModalStore } from '~/stores/product-modal'
import type { WishlistItemProduct } from './wishlist-item-product'

const props = defineProps<{
  item: WishlistItemProduct
}>()

const isLoadingModal = ref(false)

const productModal = useProductModalStore()

const addToBasket = (product: WishlistItemProduct) => {
  isLoadingModal.value = true

  productModal.openModalForProduct(product.productId, 1, product.variationId, product.optionIds, () => {
    isLoadingModal.value = false
  })
}
</script>
